export class PessoaJuridicaView {

  id: number;
  cnpj: string;
  razaoSocial: string;
  situacaoPessoa: SituacaoPessoa;

}

export class SituacaoPessoa {
  id: number;
  nome: string;
}